import { Primitive } from '../../../types/blocks/Primitive';

const LottieBlock: Primitive = {
  name: 'LottieBlock',
  friendlyName: 'Lottie',
  isInput: false,
  isPrimitive: true,
  isAvailableInEditor: true,
  tags: ['Media'],
  properties: {
    source: {
      type: 'JSON',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
    width: {
      type: 'Number',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
    height: {
      type: 'Number',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
    speed: {
      friendlyName: 'Animation Speed',
      type: 'Number',
      default: 1,
      validators: [
        {
          name: 'Max',
          value: 5,
        },
        {
          name: 'Min',
          value: 0,
        },
      ],
    },
  },
  publishes: {
    // @ts-expect-error ts-migrate(2741) FIXME: Property 'action' is missing in type '{ type: "Eve... Remove this comment to see the full error message
    click: {
      type: 'Event',
    },
  },
};

export default LottieBlock;
